import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarYearsListControlFn = /* @__PURE__ */ createRecipe('calendar-years-list-control', {}, [])

const calendarYearsListControlVariantMap = {}

const calendarYearsListControlVariantKeys = Object.keys(calendarYearsListControlVariantMap)

export const calendarYearsListControl = /* @__PURE__ */ Object.assign(memo(calendarYearsListControlFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarYearsListControl',
  __getCompoundVariantCss__: calendarYearsListControlFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarYearsListControlVariantKeys,
  variantMap: calendarYearsListControlVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarYearsListControlVariantKeys)
  },
  getVariantProps: calendarYearsListControlFn.getVariantProps,
})